import { type ReactNode, useState } from 'react'

import { Modal } from '@/components/ui/Modal'
import { cn } from '@/lib/utils'

/**
 * Bevestigingsdialoog met een verplichte reden. Kent geen enkel factuurbegrip en
 * wordt gedeeld door de factuuracties en het afkeuren van een inkoopfactuur.
 */
export function ReasonModal({
  title,
  description,
  confirmLabel,
  placeholder,
  rows = 3,
  icon,
  danger,
  onClose,
  onConfirm,
  pending,
}: {
  title: string
  description: string
  confirmLabel: string
  placeholder: string
  rows?: number
  icon?: ReactNode
  danger?: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  pending: boolean
}) {
  const [reason, setReason] = useState('')
  return (
    <Modal
      open
      onOpenChange={(o) => !o && onClose()}
      title={title}
      description={description}
      footer={
        <>
          <button type="button" className="btn-ghost" onClick={onClose}>
            Annuleren
          </button>
          <button
            type="button"
            className={cn('btn-primary', danger && 'bg-status-overdue hover:bg-status-overdue/90')}
            onClick={() => onConfirm(reason.trim())}
            disabled={!reason.trim() || pending}
          >
            {icon}
            {confirmLabel}
          </button>
        </>
      }
    >
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={rows}
        autoFocus
        placeholder={placeholder}
        className="field resize-none"
      />
    </Modal>
  )
}
